import Vue from 'vue'
import { createConfirmationService } from '@/util/confirmation'

export const confirmation = createConfirmationService(Vue.observable({ active: null }))

Vue.prototype.$confirm = confirmation.confirm
